import storeEvent from "../../utils/store-event";
import { get, getTrackingString } from "../../utils/object-helpers";

class {
    onCreate() {
        this.state = {
            drawerOpen: false
        };
    }
    onMount() {
        storeEvent.openOverflowDrawer.listen(() => {
            this.state.drawerOpen = true;
        });
    }
    onInput(input) {
        const infoModule = get(input, 'page.modules.PRESENCE_INFORMATION_MODULE', null);
        const overflowBtn = get(infoModule, 'overflowButton', null);
        const storeName = get(infoModule, 'displayName.textSpans.0.text', '');
        const closeDrawerText = get(infoModule, 'closeDrawer.textSpans.0.text', '');
        const shareModule = get(input, 'page.modules.SHARE_MODULE', null);
        let share;
        if (shareModule) {
            share = {
                btnAriaLabel: get(shareModule, 'shareAction.accessibilityText', ''),
                btnLabel: get(shareModule, 'text', ''),
                tracking: getTrackingString(shareModule, 'shareAction.action.trackingList')
            };
        }
        return {
            overflowBtn,
            storeName,
            share,
            closeLabel: closeDrawerText,
            page: input.page
        }
    }
    openShareDrawer() {
        this.closeDrawer();
        storeEvent.openShareDrawer.dispatch();
    }
    closeDrawer() {
        this.state.drawerOpen = false;
    }
}

<if(input.overflowBtn)>
    <ebay-drawer-dialog
        class="str-overflow-drawer"
        a11y-close-text=input.closeLabel
        aria-labelledby="str-overflow-drawer-title"
        open=state.drawerOpen
        on-close("closeDrawer")
        on-expanded("emit", "expanded")
        on-collapsed("emit", "collapsed")
        on-open("emit", "open")>
        <@header id="str-overflow-drawer-title">
            <ebay-profile-24-icon aria-hidden="true"/>
            <span>${input.storeName}</span>
        </@header>
        <str-follow-button page=input.page />
        <str-contact-link page=input.page />
        <if(input.share)>
            <button
                on-click("openShareDrawer")
                data-track=input.share.tracking
                aria-label=input.share.btnAriaLabel
                class="str-overflow-drawer__share-button">
                <ebay-share-ios-16-icon/>
                <span class="str-overflow-drawer__share-button__text">${input.share.btnLabel}</span>
            </button>
        </if>
    </ebay-drawer-dialog>
</if>
